<script setup>
// *** Vue ***
import { defineEmits } from "vue";

// *** Vue router ***
import { useRoute, useRouter } from "vue-router";

// *** Tanstack vue query ***
import { useMutation } from "@tanstack/vue-query";

// *** Mutation functions(callback) ***
import { dynamicWarmupFn } from "@/api/dashbaord/mutations/dashboardAPIMutationsFn";

// *** Router instance ***
const router = useRouter();

// *** Route instance ***
const route = useRoute();

// *** Emits ***
const emits = defineEmits(["resetDynamicModalSwitch"]);

// *** Dynamic warmup mutation ***
const { isLoading: dynamicWarmupIsLoading, mutate: dynamicWarmupMutate } = useMutation({
    mutationKey: ["dynamic-warmup-mutation"],
    mutationFn: dynamicWarmupFn,
    onSuccess() {
        router.back();
    }
});

// *** Handle do it button ***
const handleDoItButton = () => {
    dynamicWarmupMutate({ credenttial_id: route.query.credenttialID, dynamic_warmup: true });
};

// *** Handle close modal ***
const handleCloseModalButton = () => {
    emits("resetDynamicModalSwitch");
    router.back();
};
</script>

<template>
    <SweetAlert
        alertID="dynamicWarmupAlert"
        type="info"
        title="Dynamic Warmup"
        description="By activating dynamic warm-up, the cost of your service will be 2.5x."
        @close="handleCloseModalButton"
    >
        <template v-slot:buttons>
            <Button hoverType="opacity" @click="handleDoItButton" :loading="dynamicWarmupIsLoading">Do it</Button>
            <Button
                :outlined="true"
                hoverType="opacity"
                :loading="dynamicWarmupIsLoading"
                @click="handleCloseModalButton"
                >Cancel</Button
            >
        </template>
    </SweetAlert>
</template>
